import { createBrowserClient } from '@supabase/ssr'
import type { SupabaseClient } from '@supabase/supabase-js'

// Singleton instance
let client: SupabaseClient | undefined

export const createClient = () => {
    // Return existing client if already created
    if (client) {
        return client
    }

    // Create new client with cookie storage for OAuth PKCE flow
    client = createBrowserClient(
        process.env.NEXT_PUBLIC_SUPABASE_URL!,
        process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
        {
            cookies: {
                get(name: string) {
                    // Only access document in browser
                    if (typeof window === 'undefined') return undefined;
                    const value = `; ${document.cookie}`;
                    const parts = value.split(`; ${name}=`);
                    if (parts.length === 2) return parts.pop()?.split(';').shift();
                },
                set(name: string, value: string, options: any) {
                    // Only set cookies in browser
                    if (typeof window === 'undefined') return;
                    let cookie = `${name}=${value}`;
                    if (options?.maxAge) cookie += `; max-age=${options.maxAge}`;
                    if (options?.path) cookie += `; path=${options.path}`;
                    if (options?.sameSite) cookie += `; samesite=${options.sameSite}`;
                    document.cookie = cookie;
                },
                remove(name: string, options: any) {
                    // Only remove cookies in browser
                    if (typeof window === 'undefined') return;
                    let cookie = `${name}=; Max-Age=0`;
                    if (options?.path) cookie += `; path=${options.path}`;
                    document.cookie = cookie;
                }
            }
        }
    )

    return client
}
